import { Vpc, VpcSaveProgressStatusEnum } from './vpcTypes';
import { ConfirmationSummaryShareDesignStateEnum } from '@inter-ikea-kompis/component-configuration-summary';

const defaultState: Vpc = {
  load: {
    code: '',
    state: false,
  },
  save: {
    code: '',
    state: ConfirmationSummaryShareDesignStateEnum.default,
    dirtyConfiguration: false,
    progressStatus: VpcSaveProgressStatusEnum.default,
  },
  vpcErrorList: [],
};

export default defaultState;
